import React from 'react';
import type { ArtifactRendererProps } from './types';
import { registerArtifactRenderer } from './registry';
import { WorkflowNodeArtifact } from '@cotera/client/app/v1/workflow/workflow-node-artifact';
import type { DrillTarget } from '@cotera/client/app/v1/workflow/workflow-drill-context';
import { Text } from '@cotera/client/app/components/ui';

type WorkflowNodePayload = {
  workflowId?: string;
  target?: DrillTarget;
};

/**
 * Renders a workflow node/trigger's config form as an artifact (TJ's "click a
 * node → open it as an artifact" model). The payload carries the workflow id and
 * the drill target captured at click time.
 */
const WorkflowNodeArtifactRenderer: React.FC<ArtifactRendererProps> = ({
  artifact,
}) => {
  const payload = artifact.payload as WorkflowNodePayload;
  const workflowId = payload?.workflowId;
  const target = payload?.target ?? null;

  if (workflowId === undefined || workflowId === '' || target === null) {
    return (
      <div className="h-full w-full flex items-center justify-center bg-background p-4">
        <Text.P className="text-muted-foreground">
          Workflow step not found
        </Text.P>
      </div>
    );
  }

  return (
    <WorkflowNodeArtifact
      workflowId={workflowId}
      artifactId={artifact.artifactId}
      target={target}
    />
  );
};

registerArtifactRenderer('workflow-node', WorkflowNodeArtifactRenderer);
